import Configuration from "./configProvider";

export default {
  api: {
    url: Configuration.value("apiUri"),
  },
  auth: {
    idDomain: Configuration.value("idDomain"),
    clientId: Configuration.value("clientId"),
    scope: Configuration.value("scope"),
  },
  devServer: {
    public: "localhost",
  },
};
